import { siteApiSlice } from "../../app/siteApiSlice";
import { PeerReviewListItemViewModel } from "../peerReviews/peerReviewsApiSlice";
import { DraftStatus, WritingAction } from "../writing/writingApiSlice";

export enum StatCategories {
	Drafts = "Drafts Written",
	Lessons = "Lessons Completed",
	Reviews = "Reviews Completed",
	Messages = "New Messages",
	Score = "Average Draft Score",
}

export interface StatsViewModel {
	sectionName: StatCategories;
	week: number;
	month: number;
	allTime: number;
}

export interface HomeCoursePromptViewModel {
	coursePromptId: number;
	promptId: number;
	promptName: string;
	genre: string;
	dueDate: Date;
	isDueDateRequired: boolean;
	isPastDue: boolean;
	isAssigned: boolean;
	allowReviews: boolean;
}

export interface HomeTutorialInfoViewModel {
	tutorialId: number;
	tutorialName: string;
	tutorialCategory: string;
	codeName: string;
	isAssigned?: boolean;
}

export interface WriterHomeSpaViewModel {
	courseCreateDate: string;
	coursePrompts: HomeCoursePromptViewModel[];
	writing: WriterHomeSpaWritingViewModel[];
	reviews: PeerReviewListItemViewModel[];
	lessons: WriterHomeSpaLessonsViewModel[];
	allStats: StatsViewModel[];
	alerts: Record<number, string>;
}

export interface WriterHomeSpaWritingViewModel {
	coursePromptId: number;
	draftTitle: string;
	status: DraftStatus;
	step: string;
	lastUpdateDate?: string;
	action: WritingAction;
	actionId?: number;
}

export interface WriterHomeSpaLessonsViewModel {
	tutorialInfo: HomeTutorialInfoViewModel;
	timeSpentSeconds?: number;
	timeStarted?: Date;
}

export interface ProctorHomeSpaViewModel {
	courseCreateDate: string;
	coursePrompts: HomeCoursePromptViewModel[];
	writing: ProctorHomeSpaReviewsOrWritingViewModel[];
	reviews: ProctorHomeSpaReviewsOrWritingViewModel[];
	lessons: ProctorHomeSpaLessonsViewModel[];
	allStats: StatsViewModel[];
	alerts: Record<number, string>;
}

export interface ProctorHomeSpaReviewsOrWritingViewModel {
	coursePromptId: number;
	progress: ProgressCounts;
}

export interface ProctorHomeSpaLessonsViewModel {
	tutorialInfo: HomeTutorialInfoViewModel;
	progress: ProgressCounts;
}

export interface ProgressCounts {
	startedAmount: number;
	completedAmount: number;
	assignedAmount: number;
	allComplete: boolean;
}

export const homeApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		writerHome: build.query<WriterHomeSpaViewModel, void>({
			query: () => ({
				url: `/Home/WriterHomeSpa`,
			}),
			providesTags: [
				"CurrentCourse",
				"LessonHistory",
				"PeerReview",
				"WritingHistory",
				"Notifications",
				"Alerts",
			],
		}),
		proctorHome: build.query<ProctorHomeSpaViewModel, void>({
			query: () => ({
				url: `/Home/ProctorHomeSpa`,
			}),
			providesTags: ["CurrentCourse", "LessonHistory", "Prompts", "WritingHistory", "Alerts"],
		}),
	}),
});

export const { useWriterHomeQuery, useProctorHomeQuery } = homeApiSlice;
